window.onload = function() {
// 
}